import { createHubMap, PREVIEW_CAMERA_TILE, SPAWN_TILE } from "./worlds.js";

/** @deprecated Hub is the shared park. Kept so older imports still compile. */
export function createParkMap() {
  return createHubMap();
}

export { PREVIEW_CAMERA_TILE, SPAWN_TILE };
